export enum DataHubEntities {
  COMMUNITY = 'community'
}

export type DataHubEntityTypes = `${DataHubEntities}`
